import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { HeroDashboard } from "@/components/HeroDashboard";

const container = { hidden: {}, show: { transition: { staggerChildren: 0.1, delayChildren: 0.1 } } };
const item = { hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } } };

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-28 sm:pt-36 lg:pt-40 pb-16 sm:pb-24 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 grain-overlay opacity-60" />
      <div className="pointer-events-none absolute -top-40 right-0 w-[520px] h-[520px] rounded-full bg-blue-100/40 blur-3xl" />
      <div className="pointer-events-none absolute top-20 -left-40 w-[420px] h-[420px] rounded-full bg-slate-100/70 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-[1.05fr_1fr] gap-12 lg:gap-16 items-center">
          <motion.div variants={container} initial="hidden" animate="show">
            <motion.div variants={item}>
              <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-xs font-bold tracking-[0.18em] uppercase text-blue-600 shadow-sm">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-600" />
                Workspace Product
              </span>
            </motion.div>

            <motion.h1 variants={item} data-testid="hero-headline"
              className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-bold font-heading tracking-tighter leading-[1.05] text-slate-900">
              Verified Manufacturers™
            </motion.h1>

            <motion.p variants={item} className="mt-5 text-xl sm:text-2xl font-semibold text-slate-800 leading-snug">
              Source with confidence. <span className="text-blue-600">Work only with verified Turkish manufacturers.</span>
            </motion.p>

            <motion.p variants={item} className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl">
              Access a curated network of export-ready Turkish manufacturers that have been verified before they become part of your sourcing process.
            </motion.p>

            <motion.div variants={item} className="mt-8">
              <a href="#suppliers" data-testid="hero-primary-cta"
                className="bg-blue-600 text-white rounded-full px-7 py-4 text-sm sm:text-base font-medium hover:bg-blue-700 transition-all duration-300 shadow-sm hover:shadow-md hover:-translate-y-0.5 inline-flex items-center justify-center gap-2 group">
                Explore Verified Manufacturers
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
            className="relative">
            <HeroDashboard />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
